import {IContractData} from "./IContractData";
import {NpmServiceAdapter} from "./NpmServiceAdapter";

export class NpmBackupServiceAdapter extends NpmServiceAdapter {

    protected readonly contractsApiPath = "contractManagement/npm/backup";
    private baseNpmContractsApiPath = "contractManagement/npm";
    disableDeactivateAllTenantsButton = false;
    disableActivateAllTenantsButton = false;
    disableDeactivateButton = false;
    disableActivateButton = false;

    activateBackupForAllTenants(): void {
        this.disableDeactivateAllTenantsBackupButton();
        this.confirmationService.confirm({
            message: "Are sure you want to activate backup contracts for all tenants",
            accept: () => {
                super.put<IContractData[]>(this.baseNpmContractsApiPath, {
                    action: "OPEN_BACKUP",
                    contracts: [],
                    tenants: this.getAllTenants()
                });
            }
        });
    }

    deactivateBackupForAllTenants(): void {
        this.disableActivateAllTenantsBackupButton();
        this.confirmationService.confirm({
            message: "Are sure you want to deactivate backup contracts for all tenants",
            accept: () => {
                super.put<IContractData[]>(this.baseNpmContractsApiPath, {
                    action: "CLOSE_BACKUP",
                    contracts: [],
                    tenants: this.getAllTenants()
                });
            }
        });
    }

    activateBackup(): void {
        this.disableDeactivateBackupButton();
        this.confirmationService.confirm({
            message: "Are sure you want to activate backup contracts",
            accept: () => {
                super.put<IContractData[]>(this.baseNpmContractsApiPath, {
                    action: "OPEN_BACKUP",
                    contracts: [],
                    tenants: [this.getCurrentTenantId()]
                });
            }
        });
    }

    deactivateBackup(): void {
        this.disableActivateBackupButton();
        this.confirmationService.confirm({
            message: "Are sure you want to deactivate backup contracts",
            accept: () => {
                super.put<IContractData[]>(this.baseNpmContractsApiPath, {
                    action: "CLOSE_BACKUP",
                    contracts: [],
                    tenants: [this.getCurrentTenantId()]
                });
            }
        });
    }

    disableDeactivateAllTenantsBackupButton(): void {
        this.disableDeactivateAllTenantsButton = true;
        this.disableActivateButton = true;
        this.disableDeactivateButton = true;
        setTimeout(() => {
            this.disableDeactivateAllTenantsButton = false;
            this.disableActivateButton = false;
            this.disableDeactivateButton = false;
        }, 60000);
    }

    disableActivateAllTenantsBackupButton(): void {
        this.disableActivateAllTenantsButton = true;
        this.disableActivateButton = true;
        this.disableDeactivateButton = true;
        setTimeout(() => {
            this.disableActivateAllTenantsButton = false;
            this.disableActivateButton = false;
            this.disableDeactivateButton = false;
        }, 60000);
    }

    disableDeactivateBackupButton(): void {
        this.disableDeactivateButton = true;
        this.disableActivateAllTenantsButton = true;
        this.disableDeactivateAllTenantsButton = true;
        setTimeout(() => {
            this.disableDeactivateButton = false;
            this.disableActivateAllTenantsButton = false;
            this.disableDeactivateAllTenantsButton = false;
        }, 60000);
    }

    disableActivateBackupButton(): void {
        this.disableActivateButton = true;
        this.disableActivateAllTenantsButton = true;
        this.disableDeactivateAllTenantsButton = true;
        setTimeout(() => {
            this.disableActivateButton = false;
            this.disableActivateAllTenantsButton = false;
            this.disableDeactivateAllTenantsButton = false;
        }, 60000);
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/NpmBackupServiceAdapter.ts